// Aside.js
import React, {useContext} from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Dashboard from "./Dashboard";
import Chat from "./Chat";
import User from "./Master/User";
import District from "./Master/District";
import Taluka from "./Master/Taluka";
import Village from "./Master/Village";
import Office from "./Master/Office";
import Parlimenteryconst from "./Master/Parlimenteryconst";
import Assemblycons from "./Master/Assemblycons";
import Work from "./Works/Work";
import WorkPropose from "./Works/WorkPropose";
import Worklist from "./Works/Worklist";
import Workproposelist from "./Works/Workproposelist";
import Partwork from "./Partwork/Partwork";
import PartworkPropose from "./Partwork/PartworkPropose";
import Partworklist from "./Partwork/Partworklist";
import Partworkproposelist from "./Partwork/Partworkproposelist";
import Partworkdetails from "./Partwork/Partworkdetails";
import Login from './Login'
import Register from './Register'
import OfficeSetup from './OfficeSetup'
import Error from './Error'
import Contractor from './Contractor/Contractor'
import Contractorlist from './Contractor/Contractorlist'
import {MyContext} from '../Actions/UAuth'

function  Aside () {
  const {rootState,logoutUser} = useContext(MyContext);
  const {isAuth,showLogin} = rootState;     
  if(isAuth)
  {
        return (<Router>
				  <aside className="main-sidebar" style={{textAlign: 'justify',textJustify: 'inter-word'}}> 
					<section className="sidebar">	
					  <ul className="sidebar-menu" data-widget="tree">
						<li className="header">MAIN NAVIGATION</li>
						<li><Link to={"/"} ><i className="fa fa-dashboard"></i><span>Dashboard</span></Link></li>            
            <li className="treeview">
            <Link to={"#"}><i className="fa fa-random"></i><span>Office Setup</span>
            <i className="fa fa-angle-left pull-right"></i>
            </Link>
            <ul className="treeview-menu">
                <li><Link to={"/officesetup"}><i className="fa fa-building"></i><span>Office Setup</span></Link></li>
                <li><Link to={"/officelist"}><i className="fa fa-list"></i><span>Office List</span> </Link></li>
             </ul>
             </li>
            <li className="treeview">
            <Link to={"#"}><i className="fa fa-database"></i><span>Master</span>
            <i className="fa fa-angle-left pull-right"></i>
            </Link>
              <ul className="treeview-menu">
                <li>
                    <Link to={"/userslist"}><i className="fa fa-list"></i><span>Users List</span> </Link>                    
                    <Link to={"/districtlist"}><i className="fa fa-list"></i><span>District List</span> </Link>
                    <Link to={"/talukalist"}><i className="fa fa-list"></i><span>Taluka List</span> </Link>
                    <Link to={"/villagelist"}><i className="fa fa-list"></i><span>Village List</span> </Link>
                    <Link to={"/parlimenteryconst"}><i className="fa fa-list"></i><span>Parlimentery Constituency</span> </Link>
                    <Link to={"/assemblycons"}><i className="fa fa-list"></i><span>Assembly Constituency</span> </Link>
                </li>
              </ul>
            </li> 
            <li className="treeview">
            <Link to={"#"}><i className="fa fa-cogs"></i><span>Work Master</span>
            <i className="fa fa-angle-left pull-right"></i>
            </Link>
              <ul className="treeview-menu">
                <li><Link to={"/work"}><i className="fa fa-edit"></i><span>Work Add</span></Link></li>
                <li><Link to={"/worklist"}><i className="fa fa-list"></i><span>Work List</span> </Link></li>
                <li><Link to={"/workpropose"}><i className="fa fa-edit"></i><span>Work Proposal Add</span></Link></li>
                <li><Link to={"/workproposelist"}><i className="fa fa-list"></i><span>Work Proposal List</span> </Link></li>
              </ul>
            </li> 
            <li className="treeview">
            <Link to={"#"}><i className="fa fa-cog"></i><span>Partwork Master</span>
            <i className="fa fa-angle-left pull-right"></i>
            </Link>
              <ul className="treeview-menu">
                <li><Link to={"/partworklist"}><i className="fa fa-list"></i><span>PartWork List</span> </Link></li>
                <li><Link to={"/partworkproposelist"}><i className="fa fa-list"></i><span>PartWork Propose List</span> </Link></li>
              </ul>
            </li>  
            <li className="treeview">
            <Link to={"#"}><i className="fa fa-user-secret"></i><span>Contractor Master</span>
            <i className="fa fa-angle-left pull-right"></i>
            </Link>
              <ul className="treeview-menu">
                <li><Link to={"/contractor"}><i className="fa fa-plus"></i><span>Contractor ADD</span> </Link></li>
                <li><Link to={"/contractorlist"}><i className="fa fa-list"></i><span>Contractor List</span> </Link></li>                
              </ul>
            </li>      
            <li><Link to={"#"} onClick={logoutUser}><i className="fa fa-sign-out"></i><span>Logout</span></Link></li>                       
					  </ul>
					</section>
				  </aside> 
		<div className="App">  
        <div className="auth-wrapper">
            <div className="auth-inner">
            <Switch>
                <Route exact path='/' component={Dashboard} />
                <Route exact path='/chat' component={Chat} />
                <Route path="/userslist" component={User} />
                <Route path="/officelist" component={Office} />
                <Route path="/parlimenteryconst" component={Parlimenteryconst} />
                <Route path="/assemblycons" component={Assemblycons} />
				        <Route path="/districtlist" component={District} />
                <Route path="/talukalist" component={Taluka} /> 
                <Route path="/villagelist" component={Village} /> 
                <Route path='/work/:id' component={Work} />  
                <Route path='/workpropose/:id' component={WorkPropose} />  
                <Route path="/work" component={Work} />                   
                <Route path="/workpropose" component={WorkPropose} />                   
                <Route path="/worklist" component={Worklist} /> 
                <Route path="/workproposelist" component={Workproposelist} /> 
                <Route path="/partworklist" component={Partworklist} />
                <Route path="/partworkproposelist" component={Partworkproposelist} />
                <Route path="/partwork/:workhead/:partworkhead/:officecode" component={Partwork} /> 
                <Route path="/partwork/:id" component={Partwork} />               
                <Route path="/partworkpropose/:id" component={PartworkPropose} />               
                <Route path="/contractor/:id" component={Contractor} /> 
                <Route path="/contractor" component={Contractor} />                 
                <Route path="/contractorlist" component={Contractorlist} /> 
                <Route path="/officesetup/:id" component={OfficeSetup} /> 
                <Route path="/officesetup" component={OfficeSetup} />            
                <Route path="/partworkdetails/:workhead/:partworkhead/:officecode" component={Partworkdetails} />            
                <Route component={Error} />       
            </Switch>
            </div>
        </div>       
        </div>
        </Router>
      )
  }
  else if(showLogin){
    return <Login/>;
}
else{
    return <Register/>;
}  
}
export default Aside;